import { render, staticRenderFns } from "./CosExeRepComment.vue?vue&type=template&id=39a19474&scoped=true"
import script from "./CosExeRepComment.vue?vue&type=script&lang=js"
export * from "./CosExeRepComment.vue?vue&type=script&lang=js"
import style0 from "./CosExeRepComment.vue?vue&type=style&index=0&id=39a19474&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a19474",
  null
  
)

export default component.exports